require('./modal.js');

Pegasus.FooterFieldsModal = Pegasus.Modal.extend({
  title: function(){
    return Em.I18n.t('instructions.update_required_fields');
  }.property(),
  width: '600px',

  classNames: ['vr-collect-required-fields'],

  submitDisabled: false,
  cancelEnabled: false,
  hasFooter: true,

  bodyTemplateName: 'modals/footer_fields',

  headerClassName: 'editor-modal-header',
  bodyClassName: 'editor-modal-body',
  footerClassName: 'editor-modal-footer',

  didSubmit: function(){
    this.get('controller').set('presenter', null);
    this.get('controller').send('saveAndContinue');
  },

  didCancel: function(){
    this.get('controller').set('presenter', null);
  }
});
